import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { url } from './request';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: false,
    backend: {
      loadPath: `${url}/locale/file`,
      requestOptions: {
        credentials: 'include',
      },
      customHeaders: {
        Accept: 'application/json',
      },
    },
  });

export default i18n;
